var map = {
	"./AR.webp": "./src/assets/images/login/country/h5/AR.webp",
	"./AT.webp": "./src/assets/images/login/country/h5/AT.webp",
	"./AU.webp": "./src/assets/images/login/country/h5/AU.webp",
	"./BR.webp": "./src/assets/images/login/country/h5/BR.webp",
	"./CH.webp": "./src/assets/images/login/country/h5/CH.webp",
	"./CL.webp": "./src/assets/images/login/country/h5/CL.webp",
	"./CN.webp": "./src/assets/images/login/country/h5/CN.webp",
	"./CO.webp": "./src/assets/images/login/country/h5/CO.webp",
	"./DE.webp": "./src/assets/images/login/country/h5/DE.webp",
	"./DN.webp": "./src/assets/images/login/country/h5/DN.webp",
	"./EG.webp": "./src/assets/images/login/country/h5/EG.webp",
	"./FL.webp": "./src/assets/images/login/country/h5/FL.webp",
	"./FR.webp": "./src/assets/images/login/country/h5/FR.webp",
	"./HK.webp": "./src/assets/images/login/country/h5/HK.webp",
	"./ID.webp": "./src/assets/images/login/country/h5/ID.webp",
	"./IN.webp": "./src/assets/images/login/country/h5/IN.webp",
	"./IT.webp": "./src/assets/images/login/country/h5/IT.webp",
	"./KH.webp": "./src/assets/images/login/country/h5/KH.webp",
	"./KO.webp": "./src/assets/images/login/country/h5/KO.webp",
	"./KW.webp": "./src/assets/images/login/country/h5/KW.webp",
	"./LX.webp": "./src/assets/images/login/country/h5/LX.webp",
	"./MX.webp": "./src/assets/images/login/country/h5/MX.webp",
	"./MY.webp": "./src/assets/images/login/country/h5/MY.webp",
	"./NL.webp": "./src/assets/images/login/country/h5/NL.webp",
	"./NW.webp": "./src/assets/images/login/country/h5/NW.webp",
	"./PE.webp": "./src/assets/images/login/country/h5/PE.webp",
	"./PL.webp": "./src/assets/images/login/country/h5/PL.webp",
	"./PT.webp": "./src/assets/images/login/country/h5/PT.webp",
	"./PY.webp": "./src/assets/images/login/country/h5/PY.webp",
	"./SA.webp": "./src/assets/images/login/country/h5/SA.webp",
	"./SG.webp": "./src/assets/images/login/country/h5/SG.webp",
	"./SP.webp": "./src/assets/images/login/country/h5/SP.webp",
	"./SW.webp": "./src/assets/images/login/country/h5/SW.webp",
	"./TH.webp": "./src/assets/images/login/country/h5/TH.webp",
	"./TR.webp": "./src/assets/images/login/country/h5/TR.webp",
	"./UK.webp": "./src/assets/images/login/country/h5/UK.webp",
	"./US.webp": "./src/assets/images/login/country/h5/US.webp",
	"./VT.webp": "./src/assets/images/login/country/h5/VT.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/login/country/h5 sync recursive ^\\.\\/.*\\.webp$";